import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { API_BASE } from './config';

// directLoginPortal: when set, an unauthenticated visitor is sent straight
// into Google's OAuth flow for that portal instead of landing on the
// portal-picker page first — used for /admin so a bookmarked/shared admin
// link doesn't require an extra click through the generic login screen. A
// visitor who's already logged in but simply lacks that portal's privilege
// still ends up on the portal-picker with the usual "not authorized"
// message, via the OAuth callback's own unauthorized redirect.
export default function ProtectedRoute({ portal, directLoginPortal, children }) {
  const [status, setStatus] = useState('loading'); // 'loading' | 'authorized' | 'unauthorized'

  useEffect(() => {
    fetch(`${API_BASE}/api/user`, { credentials: 'include' })
      .then(r => (r.ok ? r.json() : Promise.reject(r.status)))
      .then(user => {
        const portals = user.portals || [];
        const required = Array.isArray(portal) ? portal : [portal];
        setStatus(required.some(p => portals.includes(p)) ? 'authorized' : 'unauthorized');
      })
      .catch(() => setStatus('unauthorized'));
  }, [portal]);

  useEffect(() => {
    if (status === 'unauthorized' && directLoginPortal) {
      window.location.href = `${API_BASE}/api/glogin?portal=${directLoginPortal}`;
    }
  }, [status, directLoginPortal]);

  if (status === 'loading') return null;
  if (status === 'unauthorized') return directLoginPortal ? null : <Navigate to="/" replace />;
  return children;
}
